export default __webpack_public_path__ + "static/media/travelPlanIcon.2a97f384.svg";